function fn_wsw() {
    var $this = $(".wsw");
    $this.find("table").each(function() {
       $(this).wrap("<div class='table'></div>");
    });
}